import { gerkService } from '../services/gerk.service';


const state = {
    gerkHistory: null,
    item:null
};

const actions = {
    loadHistory({ commit },{gerkpid}) {
        commit('load');

        return gerkService.loadHistory(gerkpid)
            .then(
                gerkHistory => commit('load', gerkHistory)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    }
  
};

const mutations = {
  
    load(state, gerkHistory) {
        state.gerkHistory = gerkHistory;
    }
    
   
};

export const gerkHistory = {
    namespaced: true,
    state,
    actions,
    mutations
};
